1
var Mailto = function () {

};

Mailto.prototype = {
    replace: function () {
        var $mailtoTag = document.getElementsByTagName('a');
        var mailto = null;
        var mailtoCount = $mailtoTag.length;

        for (var i = 0; i < mailtoCount; i++) {
            if ($mailtoTag[i].getAttribute('href').indexOf('SEND:') !== -1) {
                var href = $mailtoTag[i].getAttribute('href');
                var newHref = href.replace(/__AT__/g, '@');
                newHref = newHref.replace(/SEND:/g, 'mailto:');
                // console.log(newHref);
                $mailtoTag[i].setAttribute('href', newHref);
                $mailtoTag[i].textContent = newHref.replace(/mailto:/g, '');
            }
        }
    }
};

module.exports = Mailto;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/mailto.js
 **/